import { AppProps } from "next/app";
import path from "path";

import { ErrorBoundary, ErrorScreen } from "@tm/ui/ui-container";

import { setRouter } from "@tm/insurance/navigation";
import { PlanTypeProvider } from "@tm/ui/contexts";
import { useRouter } from "next/router";
import "./styles.css";
// import "pwa-mmt-ui-header/ssr/header.css";
import "react-day-picker/dist/style.css";

// Magic import
path.resolve("./next.config.js");

function CustomApp({ Component, pageProps }: AppProps) {
  const router = useRouter();
  setRouter(router);
  return (
    <>
      <main className="app">
        <PlanTypeProvider>
          <ErrorBoundary onError={(error) => <ErrorScreen error={error} />}>
            <Component {...pageProps} />
          </ErrorBoundary>
        </PlanTypeProvider>
      </main>
    </>
  );
}

export default CustomApp;
